import React, { forwardRef, useEffect, useState } from "react";
import classnames from "classnames";

import { updateFn } from "../shared/events";

export const Textarea = forwardRef((props, ref) => {
    const [value, setValue] = useState((props.valueToTransfer ? props.valueToTransfer : props.defaultValue ? props.defaultValue : props.value) || "");

    useEffect(() => {
        const useValue = (props.valueToTransfer ? props.valueToTransfer : props.defaultValue ? props.defaultValue : props.value) || "";

        if (props.onValidatePair && useValue) {
            props.onValidatePair(useValue);
        }

        if (useValue !== value) {
            setValue(useValue);
        }
    }, [props.defaultValue, props.value, props.valueToTransfer]);

    const onChange = (e) => {
        setValue(e.currentTarget.value);

        if (props.onValidatePair) {
            props.onValidatePair(e.target.value);
        }

        if (props.onChange) {
            props.onChange(e);
        } else if (props.updateOnChange) {
            updateFn(props.updateOnChange)(e);
        }
    };

    return (
        <textarea
            ref={ref}
            id={props.name}
            placeholder={props.placeholder}
            pattern={props.pattern}
            name={props.name}
            cols={props.cols}
            disabled={props.disabled}
            hidden={props.invisible}
            maxLength={props.maxLength}
            minLength={props.minLength}
            required={props.required}
            readOnly={props.readOnly}
            rows={props.rows}
            wrap={props.wrap}
            className={classnames({ "-error": props.invalid, "disable-resize": props.disableResize })}
            value={value}
            onChange={onChange}
            onBlur={props.onBlur || updateFn(props.updateOnBlur)}
            onKeyPress={props.onKeyPress}
            onKeyUp={props.onKeyUp}
            tabIndex={props.tabIndex}
        />
    );
});
